import { getStoredUTMParams } from '../analytics/utmTracking';
import { isEmbroideryTrace } from '../../config/appVariant';

const APP_ID = 'h6lbwr6k';

// Stamps every contact/conversation with the product they're using so Fin can
// scope answers per product within this shared Intercom workspace.
const PRODUCT = isEmbroideryTrace ? 'embroiderytrace' : 'svgtrace';

function getIntercom() {
  return window.Intercom;
}

export function bootIntercom(firebaseUser, isPremium, userHash) {
  const intercom = getIntercom();
  if (!intercom || !firebaseUser) return;

  const utmParams = getStoredUTMParams();

  const planName = isPremium === 'lifetime-pro'
    ? 'lifetime-pro'
    : isPremium === 'designer-subscriber'
      ? 'designer'
      : isPremium === 'premium'
        ? 'pro'
        : 'free';

  intercom('boot', {
    app_id: APP_ID,
    // Identity verification: without user_hash, Intercom drops the custom
    // attributes below (plan/product), so Fin can't scope answers per product.
    user_hash: userHash || undefined,
    user_id: firebaseUser.uid,
    email: firebaseUser.email,
    name: firebaseUser.displayName || undefined,
    created_at: firebaseUser.metadata?.creationTime
      ? Math.floor(new Date(firebaseUser.metadata.creationTime).getTime() / 1000)
      : undefined,
    plan: planName,
    product: PRODUCT,
    utm_source: utmParams.utm_source || undefined,
    utm_medium: utmParams.utm_medium || undefined,
    utm_campaign: utmParams.utm_campaign || undefined,
  });
}

export function updateIntercom(attributes) {
  const intercom = getIntercom();
  if (!intercom) return;
  intercom('update', attributes);
}

export function shutdownIntercom() {
  const intercom = getIntercom();
  if (!intercom) return;
  intercom('shutdown');
}

export function trackIntercomEvent(eventName, metadata) {
  const intercom = getIntercom();
  if (!intercom) return;
  intercom('trackEvent', eventName, metadata);
}

export function hideIntercom() {
  const intercom = getIntercom();
  if (!intercom) return;
  intercom('update', { hide_default_launcher: true });
}

export function showIntercom() {
  const intercom = getIntercom();
  if (!intercom) return;
  intercom('update', { hide_default_launcher: false });
}
